import React, {Component} from 'react';
import {connect} from 'react-redux';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import SpecialPartsListHeader from './header';
import SpecialPartsListTable from './table';
import './specialPartsList.scss';

class SpecialParts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'partNoFilter': '',
    };
    this.handleChangeValue = this.handleChangeValue.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
    this.handleConfirmDeleteClick = this.handleConfirmDeleteClick.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.SpecialParts, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchPartNoList();
    this.props.clearSpecialPartList();
  }

  handleChangeValue(event, target) {
    const {name, value} = target;
    const updatedState = {...this.state};
    updatedState[name] = value;
    this.setState(updatedState);
  }

  handleClearClick() {
    const {clearSpecialPartList} = this.props;
    clearSpecialPartList();
    const updatedState = {...this.state};
    updatedState.partNoFilter = '';
    this.setState(updatedState);
  }

  handleSearchClick() {
    const {fetchSpecialPartList} = this.props;
    const urlParams = this.getQueryParams();
    fetchSpecialPartList(urlParams);
  }

  getQueryParams() {
    const {partNoFilter} = this.state;
    const {pageSize, pageNumber} = this.props;
    const params = {
      'partNo': partNoFilter,
      'limit': pageSize || 20,
      'offset': pageNumber || 0,
    };
    return params;
  }

  handleConfirmDeleteClick(row) {
    const {deleteSpecialPartRecord} = this.props;
    deleteSpecialPartRecord(row.partNo);
    this.handleClearClick();
  }

  handlePageSizeChange(event, data) {
    this.props.changeSpecialPartInformationPage(0);
    this.props.changeSpecialPartInformationPageSize(data.value);
  }

  handlePageClick(value) {
    this.props.changeSpecialPartInformationPage(value);
  }

  render() {
    const {loadingPartNoList, partNoList, loadingSpecialPartList, specialPartList} = this.props;
    const {pageNumber, pageSize, totalItems} = this.props;
    return (
      <div className='special-parts-list'>
        <SpecialPartsListHeader
          loadingPartNoList={loadingPartNoList}
          partNoList={partNoList}
          changeValue={this.handleChangeValue}
          filterName='partNoFilter'
          searchClick={this.handleSearchClick}
          handleClearClick={this.handleClearClick}
          value={this.state.partNoFilter}
        />
        <SpecialPartsListTable
          loadingSpecialPartList={loadingSpecialPartList}
          specialPartList={specialPartList}
          handleConfirmDeleteClick={this.handleConfirmDeleteClick}
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalItems={totalItems}
          handlePageSizeChange={this.handlePageSizeChange}
          handlePageClick={this.handlePageClick}
          onUpdate = {this.handleSearchClick}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingPartNoList': state.specialParts.loadingPartNoList,
    'partNoList': state.specialParts.partNoList,
    'loadingSpecialPartList': state.specialParts.loadingSpecialPartList,
    'specialPartList': state.specialParts.specialPartList,
    'pageNumber': state.specialParts.offset,
    'pageSize': state.specialParts.limit,
    'totalItems': state.specialParts.count,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  fetchPartNoList,
  fetchSpecialPartList,
  clearSpecialPartList,
  deleteSpecialPartRecord,
  changeSpecialPartInformationPage,
  changeSpecialPartInformationPageSize,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchPartNoList,
  fetchSpecialPartList,
  clearSpecialPartList,
  deleteSpecialPartRecord,
  changeSpecialPartInformationPage,
  changeSpecialPartInformationPageSize,
})(SpecialParts);
